import React from "react"

const MiddleArcSvg = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			width={"1920"}
			height={"155"}
			viewBox={"0 0 1920 155"}
			fill={"none"}
			{...props}
		>
			<path
				d={
					"M1920 6H1124.35C945.827 6 864.273 24.708 656.907 114.5C384.398 232.5 264.553 6 133.768 6C79.6643 6 22.0461 6 0 6"
				}
				stroke={"white"}
				stroke-width={"12"}
			/>
		</svg>
	)
}

export default MiddleArcSvg
